export const BATTERY_LEVELS = [
  'array',
  'node',
  'container',
  'bank',
  'pack',
  'module',
  'cell',
] as const;

export type BatteryLevel = (typeof BATTERY_LEVELS)[number];

export const DIM_BY_LEVEL: Record<BatteryLevel | 'site', string> = {
  site: 'frontend_id_mapping.full_frontend_system_id',
  array: 'frontend_id_mapping.full_frontend_array_id',
  node: 'frontend_id_mapping.full_frontend_node_id',
  container: 'frontend_id_mapping.full_frontend_container_id',
  bank: 'frontend_id_mapping.full_frontend_bank_id',
  pack: 'frontend_id_mapping.full_frontend_pack_id',
  module: 'frontend_id_mapping.full_frontend_module_id',
  cell: 'frontend_id_mapping.full_frontend_cell_id',
};
